<template>
  <div class="z-page-loader" v-if="visible">
    <div class="z-page-loader__box">
      <z-loading
        color="primary"
        size="medium"
        variant="dotsSpinner"
        :class="{ 'z-page-loader__icon--spaced-bottom': !!message }"
      />

      <div class="z-text z-text--large z-text--bold">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$pageLoader.setContainer(this);
  },
  data() {
    return {
      visible: false,
      message: '',
    };
  },
  methods: {
    show(message) {
      this.message = message || '';
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>
